import { Chip } from '@mui/material';

export default function EvidenceBadge({
  value,
  context,
  positiveLabel = 'Included',
  negativeLabel = 'Not included',
}) {
  const label = value ? positiveLabel : negativeLabel;
  return (
    <Chip
      size="small"
      label={label}
      color={value ? 'success' : 'default'}
      variant={value ? 'filled' : 'outlined'}
      aria-label={`${context}: ${label.toLowerCase()}`}
      sx={{ fontWeight: 700, minWidth: 94 }}
    />
  );
}
